import { FormControl, FormLabel, MenuItem, Select } from '@mui/material'
import { connectField, filterDOMProps } from 'uniforms'
import { Markdown } from '../../Markdown'
import { useCiboAutoForm } from './CiboAutoFormContext'
import { ValidationMessages } from './ValidationMessages'

interface SelectFieldProps {
  value: number | undefined | null
  onChange: (value: string | undefined) => void
  label?: string
  disabled?: boolean
  error?: any
  helperText?: string
  required?: boolean
  name: string
  placeholder?: string
  [key: string]: any // uniforms injects many props
}

function SelectField({
  value,
  onChange,
  label,
  error,
  helperText,
  disabled,
  required,
  placeholder,
  description,
  ...props
}: SelectFieldProps) {
  const { touch } = useCiboAutoForm()

  return (
    <FormControl fullWidth {...filterDOMProps(props)} required={required} disabled={disabled}>
      {label && <FormLabel component="legend">{label}</FormLabel>}

      <Select
        data-testid={`select-field-${props.name}`}
        {...filterDOMProps(props)}
        value={value ?? ''}
        required={!!required}
        disabled={disabled}
        onChange={e => {
          const v = e.target.value
          // Empty string → undefined (Uniforms best practice)
          if (v === '') onChange(undefined)
          else onChange(v as string)

          touch(props.name)
        }}
        onBlur={() => touch(props.name)}
      >
        {props.options.map((option: any) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label ?? option.value}
          </MenuItem>
        ))}
      </Select>

      <ValidationMessages fieldName={props.name} error={error} />

      {!!description && <Markdown typographyProps={{ variant: 'caption' }}>{description}</Markdown>}
    </FormControl>
  )
}

export default connectField(SelectField)
